import { Component, h } from 'preact';

import { ListResponse } from '../../../../../types';
import { InquiryGridCardDragData } from '../../../../../types/ui';
import { Inquiry, InquiryDocument } from '../../../../../types/inquiries';

import getStore from '../../../store';
import * as InquiryActions from '../../../reducers/inquiries/inquiries.actions';

import { InquiryGridCard } from './inquiry-grid-card.component';
import { InquiryGridHeaderRow } from './inquiry-grid-header-row.component';
import { InquiryGridLoadMoreTrigger } from './inquiry-grid-load-more-trigger.component';

const store = getStore();

interface InquiryGridProps {
  stageSlug: string;
  inquiries?: ListResponse<Inquiry>;

  matches?: any;
  stageFromParams?: string;

  onShowCommentsModal?: (e, keyCode: string) => void;
  onLoadTrigger?: () => void;
  onCardClicked?: (inquiry: Inquiry) => void;
  onCardDragStart?: (dragData: InquiryGridCardDragData) => void;
  onCardDragMove?: (dragData: InquiryGridCardDragData) => void;
  onCardDragEnd?: () => void;

  onCollectedClick?: (inquiry: Inquiry) => void;
}
interface InquiryGridState {
  visibleModal?: string;
  inquiryCode?: string;
}

export class InquiryGrid extends Component<InquiryGridProps, InquiryGridState> {

  constructor() {
    super();

    this.state = {
      inquiryCode: '',
    }

    console.log(this.props)
  }

  onCardDragStart(dragData: InquiryGridCardDragData) {
    if (this.props.onCardDragStart) {
      this.props.onCardDragStart(dragData);
    }
  }

  onCardDragMove(dragData: InquiryGridCardDragData) {
    if (this.props.onCardDragMove) {
      this.props.onCardDragMove(dragData);
    }
  }

  onCardDragEnd() {
    if (this.props.onCardDragEnd) {
      this.props.onCardDragEnd();
    }
  }

  onLoadTrigger() {
    if (this.props.onLoadTrigger) {
      this.props.onLoadTrigger();
    }
  }


  openDialog(dialogId: string, selectedInquiry: Inquiry) {
    const action = InquiryActions.showModal(dialogId, { selectedInquiry });
    store.dispatch(action);
  }

  wireToDialog(dialogId: string) {
    return (inquiry: Inquiry) => this.openDialog(dialogId, inquiry);
  }

  onUploadContractClick(inquiry: Inquiry) {
    store.dispatch(
      InquiryActions.showModal('upload-contract', {
        selectedInquiry: inquiry
      })
    );
  }

  getInquiryCards(props: InquiryGridProps, state: InquiryGridState) {
    if (props.inquiries) {
      return props.inquiries.results.map(
        inquiry => <InquiryGridCard
          count={props.inquiries.count}
          inquiry={ inquiry }
          stageSlug={ props.stageSlug }
          
          stageFromParams={props.stageFromParams}

          onShowCommentsModal={ this.wireToDialog('comments') }
          onShowSetFirstCallModal={ this.wireToDialog('set-first-call') }
          onShowScheduleViewingModal={ this.wireToDialog('schedule-viewing') }
          onCreateVl={ this.wireToDialog('create-vl') }
          onCreateLoi={ this.wireToDialog('create-loi') }
          onUploadOfferSent={ this.wireToDialog('upload-offer-sent') }
          onUploadOfferAccepted={ this.wireToDialog('upload-offer-accepted') }
          onCreateContractClick={ this.wireToDialog('create-contract') }
          onUploadContractClick={ this.wireToDialog('upload-contract') }

          onEditInvoiceNumberClick={ this.wireToDialog('edit-invoice-number') }
          onEditCollectionAmountClick={ this.wireToDialog('edit-collection-amount') }
          onEditCommissionAmountClick={ this.wireToDialog('edit-commission') }

          onCollectedClick={ props.onCollectedClick }

          onCardClicked={ props.onCardClicked }
          onCardDragStart={ dragData => this.onCardDragStart(dragData) }
          onCardDragMove={ dragData => this.onCardDragMove(dragData) }
          onCardDragEnd={ () => this.onCardDragEnd() } />
      );
    }
  }

  render(props: InquiryGridProps, state: InquiryGridState) {
    return (
      <div className="hi-inqgrid">
        <InquiryGridHeaderRow stageSlug={ props.stageSlug } />
        { this.getInquiryCards(props, state) }
        <InquiryGridLoadMoreTrigger
          inquiries={ props.inquiries }
          onLoadTriggered={ () => this.onLoadTrigger() } />
      </div>
    );
  }
}
